exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2Arg5Tci6AFIGC5caJ7iwj{white-space:pre-wrap}._1P6CQtNPGGwiTWkdkFkqUb:not(:first-child){margin-left:1.42857rem}._2EVsUlvIPvBS43S7ks7uqb,._2p6IU6CBnwhFCIr-0D2iBL{height:100%}._1ZnTNttp1tBvYWCHtgVLc9{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-top:.57143rem}._1ZjkPqJdGuDKbPWLzE9flp{-webkit-box-flex:1;-webkit-flex:1 1 100%;-moz-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;max-width:100%}@media only screen and (min-width:640px){._1ZjkPqJdGuDKbPWLzE9flp{-webkit-flex-basis:0;-ms-flex-preferred-size:0;flex-basis:0}}._1ZjkPqJdGuDKbPWLzE9flp:not(:last-child){margin-bottom:1.42857rem}@media only screen and (min-width:640px){._1ZjkPqJdGuDKbPWLzE9flp:not(:last-child){margin-bottom:0;margin-right:2.14286rem}}._1fvIzPQ4DHE9kQCmgXt9ez{margin-left:1.07143rem;padding:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentReportView_unitSummary_body": "_2Arg5Tci6AFIGC5caJ7iwj",
	"StudentReportView_card_icon": "_1P6CQtNPGGwiTWkdkFkqUb",
	"StudentReportView_student_card": "_2p6IU6CBnwhFCIr-0D2iBL",
	"StudentReportView_teachers_card": "_2EVsUlvIPvBS43S7ks7uqb",
	"StudentReportView_teachers_list": "_1ZnTNttp1tBvYWCHtgVLc9",
	"StudentReportView_teachers_item": "_1ZjkPqJdGuDKbPWLzE9flp",
	"StudentReportView_teachers_profile": "_1fvIzPQ4DHE9kQCmgXt9ez"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReport/StudentReportView/style.postcss
// module id = 1469
// module chunks = 0